document.addEventListener("DOMContentLoaded", function(){

  const btn = document.querySelector(".help-choose-trigger");
  const modal = document.getElementById("av-help-panel");
  const close = document.querySelector(".av-help-close");

  // ✅ OPEN MODAL
  if(btn && modal){
    btn.addEventListener("click", function(){
      modal.classList.add("active");

      // optional auto render
      if(window.avRenderCommercialRepair){
        window.avRenderCommercialRepair();
      }
    });
  }

  // ✅ CLOSE MODAL
  if(close && modal){
    close.addEventListener("click", function(){
      modal.classList.remove("active");
    });
  }

});

// ✅ SAFE BUTTON BINDING (DYNAMIC)
document.addEventListener("click", function(e){
 if(e.target.closest(".js-repair-btn")){
    window.avRenderCommercialRepair();
 }
});



(function(){
    const modelEl = document.getElementById('avCommercialModel');
    const issueEl = document.getElementById('avCommercialIssue');
    const priorityEl = document.getElementById('avCommercialPriority');
    const resultEl = document.getElementById('avCommercialResult');

    var issueLabels = {
      no_power: 'Will not turn on',
      low_suction: 'Low suction / poor pickup',
      clog_airflow: 'Clogged hose / airflow blockage',
      brush_roll: 'Brush not spinning / poor carpet pickup',
      burning_smell: 'Burning smell / overheating',
      cord_switch: 'Cord, plug, or switch issue',
      loud_noise: 'Loud noise / vibration',
      intermittent: 'Cuts in and out / shuts off'
    };

    var typeProfiles = {
      backpack: {
        badge: 'Backpack Commercial Vacuum Repair',
        issues: {
          no_power: {
            cause: 'Common causes include a failed switch, damaged cord, loose internal connection, worn motor components, or thermal protection trip from restricted airflow.',
            solution: [
              'Bench-test the full power path, including plug, cord, switch, and motor.',
              'Replace failed switch, cord, strain relief, or motor components as needed.',
              'Verify amp draw, airflow, and operating temperature before release.'
            ]
          },
          low_suction: {
            cause: 'Low suction is usually caused by a packed bag, dirty filters, cracked hose, loose lid seal, or blockage in the hose, wand, or floor tool.',
            solution: [
              'Clear the full airflow path from intake to exhaust.',
              'Inspect and replace worn bags, filters, gaskets, and cracked hose sections.',
              'Test suction and airflow after service to confirm commercial-grade pickup.'
            ]
          },
          clog_airflow: {
            cause: 'Commercial backpack vacuums often clog at the hose cuff, wand bend, floor tool neck, or inlet path after heavy debris pickup.',
            solution: [
              'Disassemble and clear hose, wand, and tool restrictions.',
              'Inspect for hidden blockage, hose collapse, or debris packed near the motor inlet.',
              'Reassemble and performance-test the machine under normal airflow.'
            ]
          },
          brush_roll: {
            cause: 'Backpack vacuums do not use a belt-driven carpet brush in the same way upright vacuums do. Poor pickup is more often related to airflow, floor tool wear, or blockage.',
            solution: [
              'Inspect the hose, wand, floor tool, and airflow path instead of a belt system.',
              'Check attachment wear and floor-tool fit for the surface being cleaned.',
              'Restore suction and accessory performance based on the actual cause.'
            ]
          },
          burning_smell: {
            cause: 'A burning smell usually points to airflow restriction, overheating motor components, debris contacting the fan path, or a failing motor.',
            solution: [
              'Inspect the cooling path, internal fan area, and motor housing for debris or heat damage.',
              'Replace worn motor components if overheating damage is confirmed.',
              'Run post-repair heat and airflow checks before release.'
            ]
          },
          cord_switch: {
            cause: 'Daily use can wear the plug end, cord jacket, strain relief, or power switch, especially where the cord flexes repeatedly.',
            solution: [
              'Test continuity through the full power path.',
              'Replace the cord, plug, switch, or strain relief where failure is found.',
              'Complete a safety test before return to service.'
            ]
          },
          loud_noise: {
            cause: 'Loud noise often comes from fan contact, motor wear, internal debris, or a damaged floor tool creating unstable airflow.',
            solution: [
              'Open the machine and inspect the motor, fan path, and accessory connection points.',
              'Remove debris and replace worn motor or fan-related parts as needed.',
              'Verify quieter, stable operation before release.'
            ]
          },
          intermittent: {
            cause: 'Intermittent shutoff may be caused by a failing switch, loose connection, thermal overload, or motor wear that appears only under load.',
            solution: [
              'Load-test the machine and trace the intermittent electrical fault.',
              'Repair loose power-path connections or replace failing switch or motor parts.',
              'Confirm stable operation through repeated run testing.'
            ]
          }
        }
      },

      upright: {
        badge: 'Commercial Upright Vacuum Repair',
        issues: {
          no_power: {
            cause: 'Common causes include a bad cord, failed switch, wiring fault, thermal cutoff, worn motor, or internal electrical failure.',
            solution: [
              'Test the cord, plug, switch, motor, and internal wiring path.',
              'Replace failed electrical components and correct any heat-damaged connections.',
              'Run full power and safety testing before release.'
            ]
          },
          low_suction: {
            cause: 'Low suction usually comes from a full bag, dirty filters, clogged intake path, cracked hose, fan chamber blockage, or seal leak.',
            solution: [
              'Clear the intake path, fan chamber, and internal airflow route.',
              'Replace bags, filters, seals, or cracked hoses where needed.',
              'Verify airflow and pickup performance on carpet or hard-floor testing.'
            ]
          },
          clog_airflow: {
            cause: 'Commercial uprights often clog at the base inlet, hose stretch section, fan chamber, or bag housing after heavy debris pickup.',
            solution: [
              'Open and clear the base path, hose route, and fan chamber.',
              'Inspect for damage caused by debris strikes or repeated clogging.',
              'Re-test suction and cleaning performance after reassembly.'
            ]
          },
          brush_roll: {
            cause: 'Brush-roll failure is commonly caused by a worn belt, jammed brush roll, clogged base, worn brush bearings, or drive-system damage.',
            solution: [
              'Inspect and replace the belt, brush roll, or drive components as needed.',
              'Remove hair, thread, and wrapped debris from the brush system.',
              'Set proper brush operation and test carpet pickup before release.'
            ]
          },
          burning_smell: {
            cause: 'A burning smell often points to a slipping belt, jammed brush roll, overheating motor, or heavy debris buildup restricting airflow.',
            solution: [
              'Inspect the brush drive, belt path, motor cooling path, and internal airflow system.',
              'Replace worn belts, damaged brush rolls, or overheated motor parts where needed.',
              'Confirm cooler, stable operation before return to service.'
            ]
          },
          cord_switch: {
            cause: 'Repeated commercial use can damage the cord jacket, plug end, strain relief, or switch contacts.',
            solution: [
              'Test the full power path from plug to motor.',
              'Replace failed cord, plug, switch, or strain-relief parts.',
              'Perform an electrical safety check before release.'
            ]
          },
          loud_noise: {
            cause: 'Noise and vibration often come from worn brush bearings, motor wear, debris in the fan chamber, wheel damage, or loose internal parts.',
            solution: [
              'Inspect the motor, fan chamber, brush roll, wheel assembly, and base hardware.',
              'Replace worn moving parts and remove internal debris.',
              'Verify smoother operation and lower vibration before release.'
            ]
          },
          intermittent: {
            cause: 'Intermittent shutdown or cut-out can come from a loose switch, failing motor, damaged cord, or thermal overload triggered during use.',
            solution: [
              'Run the vacuum under load and trace the intermittent fault.',
              'Replace unstable power-path or motor components as required.',
              'Repeat run testing to confirm reliable operation.'
            ]
          }
        }
      },

      widearea: {
        badge: 'Wide-Area Commercial Vacuum Repair',
        issues: {
          no_power: {
            cause: 'Wide-area machines commonly fail from cord or switch damage, motor issues, fuse/overload faults, or internal wiring problems.',
            solution: [
              'Test the main power path, switches, wiring, and drive components.',
              'Repair or replace failed electrical parts and damaged internal connections.',
              'Verify safe start-up and run performance before release.'
            ]
          },
          low_suction: {
            cause: 'Low pickup can come from clogged intake channels, blocked recovery path, worn seals, weak motor performance, or heavy debris packed in the base.',
            solution: [
              'Clear the base, intake path, and suction chamber.',
              'Inspect seals, airflow path, and motor output for commercial cleaning performance.',
              'Restore pickup and verify surface coverage under test.'
            ]
          },
          clog_airflow: {
            cause: 'Large debris, string, paper, and packed dust can block the airflow path, side channels, or pickup chamber on wide-area units.',
            solution: [
              'Disassemble and clear the full intake and airflow route.',
              'Inspect the chamber, side channels, and collection path for hidden blockage.',
              'Reassemble and test the machine under normal load.'
            ]
          },
          brush_roll: {
            cause: 'Poor brush performance on wide-area machines usually means worn brush assemblies, broken drive parts, jammed brush ends, or belt-drive issues.',
            solution: [
              'Inspect brush assemblies, end caps, drive components, and belts.',
              'Remove debris, replace worn brush or drive parts, and reset correct operation.',
              'Test coverage and pickup across the full cleaning width.'
            ]
          },
          burning_smell: {
            cause: 'A burning smell can come from overloaded brush drives, seized bearings, overheating motors, or packed debris stressing the machine.',
            solution: [
              'Inspect the brush drive, motor area, bearings, and airflow path for heat damage.',
              'Replace damaged belts, bearings, motors, or brush-drive parts as needed.',
              'Verify temperature and performance before release.'
            ]
          },
          cord_switch: {
            cause: 'Large commercial machines can develop cord, plug, switch, or wiring faults from repeated rolling, pulling, and long-route use.',
            solution: [
              'Test continuity and inspect all high-stress electrical points.',
              'Replace the failed cord, switch, or damaged connection points.',
              'Perform full safety and run testing before return.'
            ]
          },
          loud_noise: {
            cause: 'Noise is often caused by worn brush bearings, motor wear, broken drive parts, wheel wear, or debris trapped in the cleaning chamber.',
            solution: [
              'Inspect the drive path, brush assemblies, wheels, and motor housing.',
              'Replace worn bearings or drive parts and remove internal debris.',
              'Confirm smoother, quieter operation after service.'
            ]
          },
          intermittent: {
            cause: 'Intermittent running can point to unstable switches, loose wiring, thermal shutdown, or failing motor/drive components.',
            solution: [
              'Test the machine under operating load and trace the cut-out point.',
              'Repair unstable electrical connections or replace failing motor/drive parts.',
              'Confirm reliable continuous operation before release.'
            ]
          }
        }
      }
    };

    var models = {
      proteam: {
        title: 'ProTeam Super CoachVac / GoFit Backpack',
        type: 'backpack',
        bestFor: 'Popular with janitorial crews, offices, schools, churches, and medical spaces where fast above-floor cleaning and mobility matter.',
        common: [
          'Low suction from clogged hose, wand, or filter bag',
          'Switch or cord damage from daily commercial use',
          'Motor heat buildup and thermal shutoff',
          'Dust leakage from worn lid seal, latch, or gasket'
        ],
        extras: [
          'Inspect backpack shell, hose cuffs, lid seal, and harness mounting points.',
          'Check wand and floor-tool fit so the machine cleans the way the crew actually uses it.'
        ]
      },

      powrflite: {
        title: 'Powr-Flite Comfort Pro Backpack',
        type: 'backpack',
        bestFor: 'A common backpack choice for cleaning contractors, schools, churches, offices, and long cleaning routes.',
        common: [
          'Airflow loss from packed bags and clogged wand paths',
          'Power loss from switch, cord, or strain-relief wear',
          'Overheating after repeated heavy use',
          'Accessory wear causing poor pickup on edges or above-floor work'
        ],
        extras: [
          'Inspect the backpack housing, hose cuffs, tool kit, and shoulder support points.',
          'Verify airflow and accessory performance for daily janitorial use.'
        ]
      },

      sanitaire: {
        title: 'Sanitaire Tradition / SC Series Upright',
        type: 'upright',
        bestFor: 'Common in schools, hotels, retail, offices, and general janitorial routes that need dependable carpet cleaning.',
        common: [
          'Brush roll not spinning because of belt or base blockage',
          'Low suction from bag housing or fan-path clogs',
          'Cord and plug wear from repeated commercial use',
          'Motor noise, vibration, or overheating'
        ],
        extras: [
          'Inspect the base, fan chamber, bag housing, and brush-drive system.',
          'Set the upright back up for dependable daily carpet cleaning.'
        ]
      },

      hoover: {
        title: 'Hoover TaskVac / HushTone Commercial Upright',
        type: 'upright',
        bestFor: 'Used in offices, schools, hospitality spaces, and commercial cleaning routes where daily reliability matters.',
        common: [
          'Loss of suction from clogged base or dirty filters',
          'Brush problems from worn belt or jammed base',
          'Cord, switch, or plug failure',
          'Intermittent shutdown from thermal overload or power-path wear'
        ],
        extras: [
          'Inspect the upright base, cord path, brush drive, and filter route.',
          'Check performance for both carpet pickup and day-to-day operator use.'
        ]
      },

      cleanmax: {
        title: 'CleanMax Pro-Series Commercial Upright',
        type: 'upright',
        bestFor: 'A common heavy-use upright for janitorial teams, facility managers, churches, and commercial cleaning crews.',
        common: [
          'Brush-drive wear and poor carpet pickup',
          'Bag or filter restriction causing weak suction',
          'Cord and switch problems from repeated heavy use',
          'Motor noise, heat, or smell under load'
        ],
        extras: [
          'Inspect the brush system, bag housing, motor path, and daily-use wear points.',
          'Restore strong pickup and stable operation for route work.'
        ]
      },

      cleanobsessed: {
        title: 'Clean Obsessed Commercial Upright / Canister',
        type: 'upright',
        bestFor: 'Useful for mixed commercial cleaning where crews need strong pickup, hose tools, and reliable daily operation.',
        common: [
          'Weak suction from bag, filter, or hose restriction',
          'Brush-drive or base-path issues reducing pickup',
          'Cord, switch, or hose wear from routine use',
          'Noise, vibration, or intermittent performance'
        ],
        extras: [
          'Inspect hose condition, tool connection points, base path, and motor airflow.',
          'Match service to the way the unit is used on mixed surfaces.'
        ]
      },

      titan: {
        title: 'Titan Commercial Upright',
        type: 'upright',
        bestFor: 'Common for schools, offices, property teams, and janitorial routes that need sturdy day-to-day upright performance.',
        common: [
          'No power from cord, plug, or switch failure',
          'Poor pickup from clogged base, bag path, or worn brush system',
          'Burning smell from belt or brush-roll stress',
          'Loud operation from motor or brush wear'
        ],
        extras: [
          'Inspect the base, brush roll, belt path, and bag/filter route.',
          'Performance-test for daily commercial use before release.'
        ]
      },

      widearea: {
        title: 'Wide-Area 18–20 Inch Commercial Vacuum',
        type: 'widearea',
        bestFor: 'Best known in schools, large offices, retail, and broad carpeted spaces where fast coverage matters.',
        common: [
          'Brush-drive problems across a wider cleaning path',
          'Low pickup from blocked base channels or worn seals',
          'Electrical issues from heavy-duty daily use',
          'Noise, vibration, or overheating in brush or motor assemblies'
        ],
        extras: [
          'Inspect wide brush assemblies, drive components, wheels, and intake channels.',
          'Test coverage and pickup across the full cleaning width.'
        ]
      }
    };

    function priorityNote(priority){
      if(priority === 'urgent'){
        return 'For a commercial machine that is down today, call before drop-off so AceVacuums can confirm the fastest next step and what to bring with the unit.';
      }
      if(priority === 'fleet'){
        return 'If multiple janitorial vacuums are down, ask AceVacuums about batch intake, repair sequencing, and the fastest path to get your crew back in service.';
      }
      return 'For standard commercial repair drop-off, bring the full machine and the attachments your team uses most often so the problem can be diagnosed correctly the first time.';
    }

   /* function renderCommercial(){

      const modelEl = document.getElementById('avCommercialModel');
      const issueEl = document.getElementById('avCommercialIssue');
      const priorityEl = document.getElementById('avCommercialPriority');
      const resultEl = document.getElementById('avCommercialResult');

      if(!modelEl || !issueEl || !priorityEl || !resultEl){
      console.error('Commercial picker fields missing');
      return;
      }

      const model = modelEl.value;
      const issue = issueEl.value;
      const priority = priorityEl.value;

      let html = `
      <div class="av-repair-card">
      <h3>Recommended Repair Path</h3>
      <p>
      Model: <strong>${model}</strong><br>
      Issue: <strong>${issue}</strong><br>
      Priority: <strong>${priority}</strong>
      </p>

      <p>
      Recommended next step:
      Schedule diagnostic service with Ace Vacuums repair team.
      </p>
      </div>
      `;

      resultEl.innerHTML = html;
    }
      window.avRenderCommercialRepair = renderCommercial;
        */

      function renderCommercial(){

        const modelEl = document.getElementById('avCommercialModel');
        const issueEl = document.getElementById('avCommercialIssue');
        const priorityEl = document.getElementById('avCommercialPriority');
        const resultEl = document.getElementById('avCommercialResult');

        if(!modelEl || !issueEl || !priorityEl) return;

        const modelKey = modelEl.value;
        const issueKey = issueEl.value;
        const priorityKey = priorityEl.value;

        const model = models[modelKey];
        const type = typeProfiles[model.type];
        const issue = type.issues[issueKey];

        const commonList = model.common
      .map(item => `<li>${item}</li>`)
      .join('');

      const solutionList = [...issue.solution, ...model.extras]
      .map(item => `<li>${item}</li>`)
      .join('');

      const priorityText =
      priorityKey === 'urgent'
      ? 'Machine is down today'
      : priorityKey === 'fleet'
      ? 'Multiple units / fleet service'
      : 'Standard repair drop-off';

        resultEl.innerHTML='<div class="av-result-top">' +
          '<div>' +
            '<div class="av-badge">' + type.badge + '</div>' +
            '<a href="/collections/commercial-equipment"><h3>' + model.title + '</h3></a>' +
            '<p class="av-result-sub">' + model.bestFor + '</p>' +
            '<div class="av-meta">' +
              '<span>Selected issue: ' + issueLabels[issueKey] + '</span>' +
              '<span>Priority: ' + (priorityKey === 'urgent' ? 'Machine is down today' : priorityKey === 'fleet' ? 'Multiple units / fleet service' : 'Standard repair drop-off') + '</span>' +
            '</div>' +
          '</div>' +
        '</div>' +

        '<div class="av-result-grid">' +
          '<div class="av-panel">' +
            '<h4>Most common problems on this machine</h4>' +
            '<ul>' + commonList + '</ul>' +
          '</div>' +

          '<div class="av-panel">' +
            '<h4>Likely cause for "' + issueLabels[issueKey] + '"</h4>' +
            '<p>' + issue.cause + '</p>' +
          '</div>' +

          '<div class="av-panel">' +
            '<h4>AceVacuums solution</h4>' +
            '<ul>' + solutionList + '</ul>' +
          '</div>' +

          '<div class="av-panel">' +
            '<h4>Best next step</h4>' +
            '<p>' + priorityNote(priorityKey) + '</p>' +
            '<p><strong>Tip:</strong> Bring the hose, wand, powerhead or floor tool, and any part connected to the problem so diagnosis is faster and more accurate.</p>' +
          '</div>' +
        '</div>' +

        '<div class="av-cta-row">' +
          '<a href="tel:7039979292" class="av-btn av-btn-primary">Call Repair Expert</a>' +
          '<a href="tel:7039979292" class="av-btn av-btn-light">Ask About Fleet Service</a>' +
          '<a href="/pages/vacuum-store-locations" class="av-btn av-btn-light">Store Locations</a>' +
          '<a href="/collections/commercial-equipment" class="av-btn av-btn-light">Shop Commercial Equipment</a>' +
        '</div>';

         /* resultEl.scrollIntoView({
          behavior:'smooth',
          block:'start'
          }); */
 
        }// <-- function ends here

      window.avRenderCommercialRepair = renderCommercial;
       
  })();

  